module["exports"] = [
  "Lars",
  "Mikael",
  "Anders",
  "Johan",
  "Erik",
  "Per",
  "Peter",
  "Karl",
  "Thomas",
  "Jan",
  "Daniel",
  "Fredrik",
  "Andreas",
  "Hans",
  "Stefan",
  "Mohamed",
  "Mats",
  "Marcus",
  "Mattias",
  "Magnus",
  "Jonas",
  "Oskar",
  "Alexander",
  "Niklas",
  "Bengt",
  "Martin",
  "Bo",
  "Nils",
  "Viktor",
  "Patrik",
  "Björn",
  "David",
  "Leif",
  "Filip",
  "Henrik",
  "Joakim",
  "Emil",
  "Christer",
  "Ulf",
  "Sven",
  "Simon",
  "Christoffer",
  "Anton",
  "Gustav",
  "Robert",
  "Christian",
  "William",
  "Tommy",
  "Kjell",
  "Lucas",
  "Rickard",
  "Håkan",
  "Adam",
  "Göran",
  "Jakob",
  "Jonathan",
  "Rolf",
  "Lennart",
  "Robin",
  "Sebastian",
  "Elias",
  "Tobias",
  "John",
  "Stig",
  "Axel",
  "Linus",
  "Oliver",
  "Kent",
  "Hugo",
  "Isak",
  "Roger",
  "Jesper",
  "Claes",
  "Albin",
  "Ludvig",
  "Jörgen",
  "Rasmus",
  "Max",
  "Ali",
  "Jimmy",
  "Kenneth",
  "Joel",
  "Gunnar",
  "Dennis",
  "Josef",
  "Johnny",
  "Olle",
  "Liam",
  "Leo",
  "Olof",
  "Pontus",
  "Åke",
  "Kurt",
  "Kevin",
  "Samuel",
  "Edvin",
  "Gabriel",
  "Torbjörn",
  "Arvid",
  "Felix"
];
